import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  TextInput,
  Column,
} from "carbon-components-react";
import {
  ArrowRight24,
} from "@carbon/icons-react";
import Card from "../../components/Card/Card";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import http from "../../http-common";
import * as yup from "yup";

const ForgotPasswordPage = () => {

  const [showSuccess, setShowSuccess] = useState(false);

  const requiredMessage = "Campo obrigatório";

  const ressetPasswordSchema = yup.object({
    email: yup.string().email("Email inválido").required(requiredMessage),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(ressetPasswordSchema) });

  const onSubmit = async (data) => {
    try {

      await http.put(`/auth/reset/${data.email}`);
      setShowSuccess(true);

    } catch (error) {
      toast.error(error.response?.data.message);
    }
  };

  return (
    <div className="bx--row">
      <div className="bx--col-lg-4 content">

      </div>
      <div className="bx--col-lg-4">
        <Card title="Esqueceu-se da senha">
          {showSuccess ? (
            <div className="emprega-green">
              <p>
                Senha criada e enviada para o teu email.
              </p>
            </div>
          ) : (
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Column className="required">

                <TextInput
                  {...register("email")}
                  id="email"
                  labelText="Email"
                />
                <p className="field-error">{errors.email?.message}</p>

              </Column>
              <Column>
                <Button
                  type="submit"
                  renderIcon={ArrowRight24}
                  className="mt-2 btn-fluid"
                >
                  Redefinir Senha
                </Button>

                <p style={{ color: "#000", paddingTop: "10px" }}>
                  Já te registaste? Faz <Link to={"/"}>login</Link>
                </p>
              </Column>
            </Form>
          )}

        </Card>
      </div>
    </div>

  );
};
export default ForgotPasswordPage;
